import { eventCostcenterChanged } from './cam-context-switcher-constants';
import '../../scripts/global-menu-generic-icon';
import chevronIcon from '../../assets/images/icons/chevron-right.svg';

const tagName = 'cam-context-switcher-costcenter';
const template = require(`../templates/${tagName}.ejs`);

export default class CamContextSwitcherCostcenter extends HTMLElement {

  constructor(costcenterData) {
    super();
    this.costcenterData = costcenterData;
    this.onclick = this.handleClick;
  }

  connectedCallback() {
    this.classList.add(tagName);

    this.innerHTML = template(this.costcenterData);
    if (this.costcenterData.display.selected) {
      this.firstChild.classList.add('selected');
      this.firstChild.innerHTML += chevronIcon;
    }
  }

  handleClick() {
    let eventOptions = {
      detail: {
        costcenter: this.costcenterData.costcenter
      },
      bubbles: true,
      cancelable: true
    };
    this.dispatchEvent(new CustomEvent(eventCostcenterChanged, eventOptions));
  }


}

customElements.define(tagName, CamContextSwitcherCostcenter);



// WEBPACK FOOTER //
// ./src/cam-context-switcher/scripts/cam-context-switcher-costcenter.js